<h1>Probeer gratis!</h1>
<p class="text">Hier kun je in één keer een feest en een account aanmaken. Eerst is het nog een demo-feest, zo kun je de app
  uitproberen
  en krijg je een idee van hoe het er uit komt te zien en hoe leuk het is!<br/>
  Daarna kun je deze demo omzetten in een echt feest als je hem wilt gebruiken en gasten wil uitnodigen.</p>
<form bijbForm (bijbSubmit)="createEvent()" novalidate>
  <table>
    <tr>
      <td class="align-right">Naam van je feest</td>
      <td class="align-left">
        <app-form-input-errors [input]="myEventName"></app-form-input-errors>
        <input name="event-name" type="text" [(ngModel)]="eventName" required pattern=".*\S+.*" trim="blur"
               #myEventName="ngModel" />
      </td>
    </tr>
  </table>

  <app-form-buttons [resetButtonEnabled]="false"
                    [saveCaption]="'Volgende >'"></app-form-buttons>
</form>
